<div class="shared-with-me" data-cy="shared-with-me-widget" (click)="focusWidget(selectedIndex)">
  <widget-title title="Shared With Me"> </widget-title>
  <div class="widget-body">
    <smooth-height [trigger]="items" *ngIf="!isLoading">
      <section>
        <ng-scrollbar
          [sensorDebounce]="1"
          [autoHeightDisabled]="false"
          class="virtual-scroll"
          visibility="hover"
          [style.maxHeight.px]="widgetHeight"
          [style.--height-no-scroll]="noScroll ? widgetHeight + 'px' + '!important' : 'auto'"
        >
          <cdk-virtual-scroll-viewport appendOnly [itemSize]="20" ngScrollbarView smoothScroll scrollViewport [class.virtual-scroll]="true">
            <ng-container *cdkVirtualFor="let item of displayedItems; index as i">
              <result-item
                #resultItem
                [class.disabled]="item.deleted"
                [class.selected]="selectedIndex === i"
                [class.keyboardOn]="keyboardOn"
                [sessionId]="displayedContext.sessionId"
                [clientSearchId]="displayedContext.clientSearchId"
                [resourceList]="'shared_with_me'"
                [selected]="selectedIndex === i"
                class="result-item result-item-widget"
                [index]="i"
                [resultsIndex]="i"
                (invoke)="updateSelectedIndex(i); onInvoke($event, 'result')"
                (click)="updateSelectedIndex(i)"
                (mouseover)="keyboardOn = false"
                [attr.data-index]="i"
                listName="recently_viewed"
                [model]="item"
                (contextOpen)="updateSelectedIndex(i)"
                [showResultSections]="item?.showResultSections"
              ></result-item>
            </ng-container>
          </cdk-virtual-scroll-viewport>
        </ng-scrollbar>
      </section>
    </smooth-height>
    <widget-no-result
      *ngIf="!isLoading && displayedContext.items && displayedContext.items.length == 0"
      title="No shared resources found"
      subtitle="Resources that have been shared with you will be grouped here"
      [imgModel]="{
        lightUrl: 'widget-recently-empty-light',
        darkUrl: 'widget-recently-empty-dark'
      }"
    >
    </widget-no-result>

    <div class="ghost-container" *ngIf="isLoading">
      <result-ghost *ngFor="let i of 8 | fill"></result-ghost>
    </div>
  </div>
</div>
